import React, { useEffect } from "react";
import moment from "moment";
import { LinkOutlined } from "@ant-design/icons";
import { Divider, Form, List, Typography } from "antd";
import { FlexContainer } from "../../../../../shared";
import { ExamplesDisplay } from "../../../../../shared/examples-display";
import {
  ScheduleExpertServiceForm
} from "../form";

export function DetailContent({
  assignedExpertService = null
}) {
  const [form] = Form.useForm();
  const { expertServiceData = {}, scheduledExpertService = null }
    = assignedExpertService || {};

  useEffect(() => {
    if (scheduledExpertService) {
      form.setFieldsValue({
        serviceDate: moment(scheduledExpertService?.serviceDate),
        serviceHour: moment(scheduledExpertService?.serviceDate),
        needs: scheduledExpertService?.needs
      });
    }
  }, [scheduledExpertService]);

  return (
    <FlexContainer direction="vertical">
      <Typography.Title strong level={5}>
        Agendar sesión
      </Typography.Title>
      <Typography.Text>
        Consulta disponibilidad del experto
      </Typography.Text>
      <Typography.Link href="https://calendly.com/mycalendar" target="_blank">
        calendly.com/mycalendar
      </Typography.Link>
      {scheduledExpertService &&
        <ScheduleExpertServiceForm form={form} readOnly />
      }
      <Divider />
      <Typography.Title strong level={5}>
        Información del servicio
      </Typography.Title>
      <br />
      <Typography.Text type="secondary">
        Descripción:
      </Typography.Text>
      <Typography.Text>
        {expertServiceData?.description}
      </Typography.Text>
      <br />
      <Typography.Text type="secondary">
        Galería de ejemplos:
      </Typography.Text>
      <ExamplesDisplay examples={expertServiceData?.examples} />
      <br />
      <Typography.Text type="secondary">
        Enlaces y archivos:
      </Typography.Text>
      <List
        size="small"
        dataSource={expertServiceData?.links}
        renderItem={link => (
          <List.Item key={link}>
            <Typography.Link
              href={link}
              target="_blank">
              <LinkOutlined /> {link}
            </Typography.Link>
          </List.Item>)
        } />
    </FlexContainer>
  );
}
